export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-background-200"></div>

      <div className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Scandinavian%20minimalist%20flat%20lay%20product%20collage%20with%20white%20sneakers%2C%20beige%20leather%20handbag%2C%20neutral%20tone%20fashion%20accessories%2C%20soft%20natural%20window%20lighting%2C%20clean%20editorial%20aesthetic%2C%20warm%20cream%20background%2C%20elegant%20composition%2C%20gentle%20diffused%20shadows%2C%20lifestyle%20product%20photography&width=1800&height=1200&seq=hero-v2-bg-collage&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-12">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 border border-background-200 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium text-foreground-600">Aggiornato 2026</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
              Itaobuy Spreadsheet:
              <br />
              <span className="text-accent-500">La guida italiana completa</span>
              <br />
              per trovare prodotti migliori
            </h1>

            <p className="text-base md:text-lg text-foreground-600 max-w-xl mb-8 leading-relaxed">
              Scopri liste prodotti organizzate, categorie aggiornate, guide dettagliate e informazioni utili per utilizzare Itaobuy Spreadsheet in modo semplice, veloce e sicuro.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
              >
                Itaobuy Sheet
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 text-base font-semibold hover:border-foreground-500 hover:text-foreground-950 transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
              >
                Buy It Now
                <i className="ri-shopping-cart-line ml-2"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 justify-center lg:justify-start text-xs text-foreground-500">
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-500"></i> Aggiornamenti frequenti</span>
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-500"></i> Guide in italiano</span>
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-500"></i> Tabelle comparative</span>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg">
            <div className="relative rounded-2xl overflow-hidden"
              style={{ aspectRatio: '4/3' }}
            >
              <img
                src="https://readdy.ai/api/search-image?query=European%20minimalist%20product%20flat%20lay%20photography%20with%20tan%20leather%20loafers%2C%20neutral%20tone%20fashion%20accessories%2C%20warm%20cream%20backdrop%2C%20soft%20natural%20window%20light%20from%20left%2C%20editorial%20aesthetic%2C%20clean%20composition%2C%20Scandinavian%20style%2C%20gentle%20warm%20shadows%2C%20elegant%20lifestyle%20product%20photography&width=800&height=600&seq=hero-v2-product-display&orientation=landscape"
                alt="Itaobuy Spreadsheet prodotti organizzati"
                title="Itaobuy Spreadsheet collezione prodotti"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <div className="w-6 h-10 rounded-full border-2 border-foreground-300 flex items-start justify-center p-1.5">
            <div className="w-1 h-2.5 rounded-full bg-foreground-300 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}